/**
 * Small display formatters shared by the admin screens. Dates arrive as
 * YYYY-MM-DD strings; the noon anchor keeps every timezone on Earth on the
 * same printed day (same trick as the public calendar).
 */

import type { Cents } from "@bivak/domain";
import { cents } from "@bivak/domain";

const DAY = new Intl.DateTimeFormat("nl-BE", { weekday: "short", day: "numeric", month: "short" });
const DAY_TIME = new Intl.DateTimeFormat("nl-BE", {
  weekday: "short",
  day: "numeric",
  month: "long",
  year: "numeric",
});

function atNoon(iso: string): Date {
  return new Date(`${iso}T12:00:00`);
}

/** "vr 4 sep – zo 6 sep", or a single day for a day rental. */
export function formatDateRange(arrivalIso: string, departureIso: string): string {
  if (arrivalIso === departureIso) return DAY.format(atNoon(arrivalIso));
  return `${DAY.format(atNoon(arrivalIso))} – ${DAY.format(atNoon(departureIso))}`;
}

/** "vr 4 september 2026", optionally with a wall-clock time: "· 18:00". */
export function formatDayLong(iso: string, time?: string | null): string {
  const day = DAY_TIME.format(atNoon(iso));
  return time ? `${day} · ${time.slice(0, 5)}` : day;
}

/** The wire sends plain integers; brand them once, at the edge. */
export function asCents(value: number): Cents {
  return cents(value);
}
